/*----------------------------------
- SALES PAGE: PERSONA CARD
----------------------------------*/

/**
 * @docs docs/features/sales-page
 * @adr  ADR-0067
 */

import PersonaAuthCtaPair from '@/client/pages/landing/components/conversion/PersonaAuthCtaPair';
import { CARD_BODY_CLASS, CARD_TITLE_CLASS, WHITE_CARD_CLASS } from '@/client/pages/landing/components/shared/pageStyles';
import { SALES_PAGE_CONTENT } from '@/client/catalogs/landing/sales/pageContent';
import { SALES_ATTRIBUTION, SALES_TRACKING_PAGE } from '../lib/salesConversion';

/*----------------------------------
- COMPONENT
----------------------------------*/

export default function SalesPersonasCard() {
    const content = SALES_PAGE_CONTENT.personas;
    return (
        <section data-testid="sales-conversion">
            <div class={`${WHITE_CARD_CLASS} flex flex-col gap-3 p-5 lg:flex-row lg:items-center lg:justify-between lg:p-8`}>
                <div class="max-w-[640px]">
                    <h2 class={CARD_TITLE_CLASS}>{content.heading}</h2>
                    <p class={`${CARD_BODY_CLASS} mt-2`}>{content.body}</p>
                </div>
                <div class="flex flex-wrap gap-3">
                    <PersonaAuthCtaPair
                        attribution={SALES_ATTRIBUTION}
                        investorTriggerId="website_sales_investor"
                        founderTriggerId="website_sales_founder"
                        page={SALES_TRACKING_PAGE}
                        section="sales_personas"
                        surface="sales"
                        size="md"
                        tone="light"
                    />
                </div>
            </div>
        </section>
    );
}
